import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaCalendarDay } from 'react-icons/fa';
import { FaTag } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Loading,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
} from '~/components';

import { Combo, GraphArea, LoadArea, Combos, ToogleInfo } from './styles';

import Grafico from './Grafico';

import RelatorioVendaDiaria from '~/@types/relatoriovendadiaria';
import RelatorioVendaDiariaDia from '~/@types/relatoriovendadiariadia';

import { anoAtual, mesAtual, nomeDoMes } from '~/helpers/date';

const Dashboard: React.FC = () => {
  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);

  //FILTROS
  const [ano, setAno] = useState(anoAtual());
  const [mes, setMes] = useState(nomeDoMes(mesAtual()));
  const [comboAnoVisibilidade, setComboAnoVisibilidade] = useState(false);
  const [comboMesVisibilidade, setComboMesVisibilidade] = useState(false);

  // VENDAS DIARIAS
  const [vendasdiarias, setVendasdiarias] = useState<RelatorioVendaDiaria[]>(
    [],
  );
  const [vendasDiariasVisibilidade, setGraficoVisibilidade] = useState(true);

  // MODULO (VENDAS DIARIAS)
  const filtrarDiasPorModulo = (
    pModuloGrafico: string,
    pGrafico: RelatorioVendaDiaria[],
  ) => {
    const dias: RelatorioVendaDiariaDia[] = [];

    let c;
    for (c in pGrafico) {
      const mes = pGrafico[c];
      if (mes.nome === pModuloGrafico) {
        let d;
        for (d in mes.dias) {
          const dia = mes.dias[d];
          dias.push(dia);
        }
      }
    }

    return dias;
  };

  const gerarRelatorioGraficoCSV = () => {
    let data: string[] = [];

    data.push('ANO;MES;DIA;PEDIDOS;PRODUTOS;FRETE;DESCONTO;TOTAL');

    const dias = filtrarDiasPorModulo(`${mes}-${ano}`, vendasdiarias);

    let d;
    for (d in dias) {
      const dia = dias[d];

      data.push(
        `${dia.ano};${dia.mesnome};${dia.dia};${dia.pedidos};${dia.produtos};${dia.frete};${dia.desconto};${dia.total}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, 'VENDAS DIARIAS');
  };

  const gerarRelatoriosGraficoPDF = () => {
    const cabecalho = [
      'ANO',
      'MES',
      'DIA',
      'PEDIDOS',
      'PRODUTOS',
      'FRETE',
      'DESCONTO',
      'TOTAL',
    ];

    const data: string[][] = [];

    const dias = filtrarDiasPorModulo(`${mes}-${ano}`, vendasdiarias);

    let d;
    for (d in dias) {
      const dia = dias[d];

      const linha: string[] = [];

      linha.push(`${dia.ano}`);
      linha.push(`${dia.mesnome}`);
      linha.push(`${dia.dia}`);
      linha.push(`${dia.pedidos}`);
      linha.push(`${dia.produtos}`);
      linha.push(`${dia.frete}`);
      linha.push(`${dia.desconto}`);
      linha.push(`${dia.total}`);

      data.push(linha);
    }

    exportPdf(cabecalho, data, 'VENDAS DIARIAS');
  };

  const exibicaoTotalPedidos = (pTotalPedidos: number) => {
    if (!pTotalPedidos) return 'Nenhum pedido';
    if (pTotalPedidos === 1) {
      return 'Um pedido';
    }
    return `${pTotalPedidos} pedidos`;
  };

  useEffect(() => {
    const fetchVendasPorDia = async () => {
      try {
        setInLoad(true);
        setVendasdiarias([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_por_dia';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setVendasdiarias(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    fetchVendasPorDia();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Vendas Diárias"
            subtitle="Confira as métricas de vendas distribuídas diariamente"
            icon={
              <>
                <FaCalendarDay size={32} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {vendasdiarias.length ? (
            <GraphArea>
              <header>
                <i>
                  <FaCalendarDay size={22} color={colors.IC1} />
                </i>
                <p>
                  <h1>Vendas diárias</h1>
                  <h2>
                    Confira as métricas de vendas distribuídas diariamente
                  </h2>
                </p>

                <div>
                  <button
                    className="excel"
                    onClick={gerarRelatorioGraficoCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatoriosGraficoPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </div>
              </header>

              <Combos>
                <Combo>
                  <div
                    onClick={() =>
                      setComboMesVisibilidade(!comboMesVisibilidade)
                    }
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>{mes}</span>
                    <i>
                      {comboMesVisibilidade ? (
                        <IoMdArrowDropup size={22} color={colors.IC1} />
                      ) : (
                        <IoMdArrowDropdown size={22} color={colors.IC1} />
                      )}
                    </i>
                  </div>
                  {comboMesVisibilidade ? (
                    <ul>
                      <li>
                        <button
                          onClick={() => {
                            setMes('janeiro');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Janeiro
                        </button>
                        <button
                          onClick={() => {
                            setMes('fevereiro');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Fevereiro
                        </button>
                        <button
                          onClick={() => {
                            setMes('março');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Março
                        </button>
                        <button
                          onClick={() => {
                            setMes('abril');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Abril
                        </button>
                        <button
                          onClick={() => {
                            setMes('maio');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Maio
                        </button>
                        <button
                          onClick={() => {
                            setMes('junho');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Junho
                        </button>
                        <button
                          onClick={() => {
                            setMes('julho');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Julho
                        </button>
                        <button
                          onClick={() => {
                            setMes('agosto');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Agosto
                        </button>
                        <button
                          onClick={() => {
                            setMes('setembro');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Setembro
                        </button>
                        <button
                          onClick={() => {
                            setMes('outubro');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Outubro
                        </button>
                        <button
                          onClick={() => {
                            setMes('novembro');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Novembro
                        </button>
                        <button
                          onClick={() => {
                            setMes('dezembro');
                            setComboMesVisibilidade(false);
                          }}
                        >
                          Dezembro
                        </button>
                      </li>
                    </ul>
                  ) : null}
                </Combo>

                <Combo>
                  <div
                    onClick={() =>
                      setComboAnoVisibilidade(!comboAnoVisibilidade)
                    }
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>{ano}</span>
                    <i>
                      {comboAnoVisibilidade ? (
                        <IoMdArrowDropup size={22} color={colors.IC1} />
                      ) : (
                        <IoMdArrowDropdown size={22} color={colors.IC1} />
                      )}
                    </i>
                  </div>
                  {comboAnoVisibilidade ? (
                    <ul>
                      <li>
                        <button
                          onClick={() => {
                            setAno('2024');
                            setComboAnoVisibilidade(false);
                          }}
                        >
                          2024
                        </button>
                        <button
                          onClick={() => {
                            setAno('2025');
                            setComboAnoVisibilidade(false);
                          }}
                        >
                          2025
                        </button>
                        <button
                          onClick={() => {
                            setAno('2026');
                            setComboAnoVisibilidade(false);
                          }}
                        >
                          2026
                        </button>
                      </li>
                    </ul>
                  ) : null}
                </Combo>
              </Combos>

              <main>
                <div>
                  <Grafico
                    dias={filtrarDiasPorModulo(`${mes}-${ano}`, vendasdiarias)}
                  />
                </div>
              </main>

              <footer>
                {vendasDiariasVisibilidade ? (
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="Periodo" />
                      <GridHeadItem title="Pedidos" width={150} />
                      <GridHeadItem title="Produtos" width={150} />
                      <GridHeadItem title="Frete" width={150} />
                      <GridHeadItem title="Desconto" width={150} />
                      <GridHeadItem title="Total" width={150} />
                    </GridLine>

                    {filtrarDiasPorModulo(`${mes}-${ano}`, vendasdiarias).map(
                      dia => (
                        <GridLine key={dia.periodo}>
                          <GridItem>{dia.nome}</GridItem>
                          <GridItem width={150}>
                            {exibicaoTotalPedidos(dia.pedidos)}
                          </GridItem>
                          <GridItem width={150}>
                            {dia.produtos.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {dia.frete.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {dia.desconto.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {dia.total.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                        </GridLine>
                      ),
                    )}
                  </Grid>
                ) : null}
                <ToogleInfo
                  onClick={() =>
                    setGraficoVisibilidade(!vendasDiariasVisibilidade)
                  }
                >
                  {vendasDiariasVisibilidade ? (
                    <IoMdArrowDropup size={32} color={colors.IC1} />
                  ) : (
                    <IoMdArrowDropdown size={32} color={colors.IC1} />
                  )}
                </ToogleInfo>
              </footer>
            </GraphArea>
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default Dashboard;
